function _slicedToArray(r, e) {
  return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest();
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e,
      n,
      i,
      u,
      a = [],
      f = !0,
      o = !1;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}
function _arrayWithHoles(r) {
  if (Array.isArray(r)) return r;
}
module.exports = function (mod) {
  return "\n  <div class=\"saito-modal videocall-setting-grid-item videocall-settings-modal\">\n    <div class=\"saito-modal-title\">".concat(mod.returnName(), " Settings</div>\n    <div class=\"saito-modal-content videocall-settings-content\">\n      <fieldset class=\"videocall-settings-group videocall-layout-options\">\n        <legend class=\"videocall-settings-heading\">Video Call Layout</legend>\n        ").concat([['focus', 'users-viewfinder', 'Focus'], ['gallery', 'table-cells', 'Gallery'], ['speaker', 'user', 'Speaker']].map(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 3),
      value = _ref2[0],
      icon = _ref2[1],
      label = _ref2[2];
    return "\n          <label class=\"videocall-settings-option\">\n            <input class=\"saito-radio videocall-option-input\" type=\"radio\"\n              name=\"videocall-option-input\" value=\"".concat(value, "\" ").concat(mod.layout === value ? 'checked' : '', ">\n            <i class=\"fa-solid fa-").concat(icon, "\" aria-hidden=\"true\"></i>\n            <span>").concat(label, "</span>\n          </label>");
  }).join(''), "\n      </fieldset>\n    </div>\n  </div>");
};